class FacetRemove extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link']
  }

  checkValidity () {
    super.checkValidity()

    if (!this.filters) {
      this.throwError(
        'facet-remove must be a descendant of collection-filters',
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.link.element, 'click', (event) => {
      event.preventDefault()

      this.filters.onLinkClick(event)
    })
  }

  /**
   * @returns {CollectionFilters|null}
   */
  get filters () {
    return this.closest('collection-filters')
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove)
}
